module.exports = __webpack_public_path__ + "static/Portrait-Regular-1bca11e180d248e3671ed96cda12cf25.woff";